import {
  SystemIconName,
  Button,
  SystemIcon,
  Typography,
  Box,
  Divider,
} from '@wishket/design-system';
import { PropsWithChildren } from 'react';
import { setCookie } from 'cookies-next';

import { Link, Icon } from '@/shared/Components';
import { GuideImage } from '@/shared/Components/Icon/parts';
import { PATH } from '@/shared/constants';

export const SocialButton = ({
  icon,
  text,
}: {
  icon: SystemIconName;
  text: string;
}) => {
  return (
    <SignupLink>
      <Button className="relative w-full">
        <SystemIcon name={icon} className="absolute left-4" />
        <Typography variant="body1" className="text-w-gray-600">
          {text}
        </Typography>
      </Button>
    </SignupLink>
  );
};

export const NewsletterSubscriptionCompleteGuideImage = () => {
  return (
    <Box className="flex h-[95px] w-[280px] items-center justify-center">
      <Box className="relative flex h-[66px] w-40 items-center justify-center gap-2 rounded-2xl border bg-w-gray-10 p-5 pl-6">
        <Typography variant="body1" className="text-w-gray-600">
          개발 콘텐츠
        </Typography>
        <Icon name="newsletter_guide_icon" />
        <GuideImage className="absolute -bottom-4 -right-[26px]" />
      </Box>
    </Box>
  );
};

export const OrDivider = () => {
  return (
    <Box className="flex w-full items-center justify-center">
      <Box className="flex-1">
        <Divider />
      </Box>
      <Typography variant="caption1" className="mx-3 text-w-gray-500">
        또는
      </Typography>
      <Box className="flex-1">
        <Divider />
      </Box>
    </Box>
  );
};

interface SignupLinkProps extends PropsWithChildren {
  email?: string;
}

export const SignupLink = ({ children, email }: SignupLinkProps) => {
  const signUpLink = `${process.env.NEXT_PUBLIC_APP_AUTH_URL}/signup?next=${PATH.HOME}`;

  const setEmailCookie = () => {
    if (!email) return;

    const encodedEmail = Buffer.from(email).toString('base64');
    setCookie('prev_email', encodedEmail);
  };

  return (
    <Link href={signUpLink} className="w-full" onClick={setEmailCookie}>
      {children}
    </Link>
  );
};
